import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { ForYou } from './components/ForYou';
import { WhatChanges } from './components/WhatChanges';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel implementation
    const pixelId = '26257470350562748';
    // Create script element
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Create noscript element
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Benefits data-id="element-2" />
      <Modules data-id="element-3" />
      <Bonuses data-id="element-4" />
      <ForYou data-id="element-5" />
      <WhatChanges data-id="element-6" />
      <Pricing data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Footer data-id="element-9" />
      <SocialProofPopup data-id="element-10" />
    </div>;
}